import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ApiOffline = () => {
    return (
        <>
            <div className="d-flex flex-column text-center justify-content-center">
                <h1 className="my-5 mx-auto">
                    OH
                    <div className="fa-layers fa-fw">
                         <FontAwesomeIcon icon='thumbs-down' color="brown" />
                    </div>!
                </h1>

                <h2 className="mt-5 mx-auto">
                    The Alliance API is unavailable
                </h2>
            </div>
        </>
    );
}

export default ApiOffline;